import React, { useEffect, useState } from "react";
import axios from "axios";

function About() {
  const API = "";
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/api/about`)
      .then((res) => {
        setData(res.data);
      })
      .catch(() => {
        setData(null);
      });
  }, []);

  if (!data) return <div className="text-center py-5">Loading...</div>;

  return (
    <section className="public-about">
      <div className="container">
        <div className="public-about__block">
          <div className="row align-items-center g-4">
            <div className="col-lg-5">
              <div className="public-about__media">
                <img src={`${API}/uploads/${data.about_image}`} alt="About institute" className="img-fluid" />
              </div>
            </div>

            <div className="col-lg-7">
              <div className="public-about__copy">
                <p className="public-about__eyebrow">About Institute</p>
                <h2>Leading the Smart Education Revolution</h2>
                <div dangerouslySetInnerHTML={{ __html: (data.about_text || "").replace(/\n/g, "<br/>") }} />
              </div>
            </div>
          </div>
        </div>

        <div className="public-about__block public-about__block--alt">
          <div className="row align-items-center g-4">
            <div className="col-lg-7 order-2 order-lg-1">
              <div className="public-about__copy">
                <p className="public-about__eyebrow">Director Message</p>
                <h2>Redefining Education for the Digital Era</h2>
                <div dangerouslySetInnerHTML={{ __html: (data.director_message || "").replace(/\n/g, "<br/>") }} />
              </div>
            </div>

            <div className="col-lg-5 order-1 order-lg-2">
              <div className="public-about__portrait">
                <img src={`${API}/uploads/${data.director_image}`} alt="Director" />
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4 mb-4">
          <div className="col-lg-6">
            <div className="public-about__panel h-100">
              <p className="public-about__eyebrow">Mission</p>
              <div dangerouslySetInnerHTML={{ __html: (data.mission || "").replace(/\n/g, "<br/>") }} />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="public-about__panel h-100">
              <p className="public-about__eyebrow">Vision</p>
              <div dangerouslySetInnerHTML={{ __html: (data.vision || "").replace(/\n/g, "<br/>") }} />
            </div>
          </div>
        </div>

        <div className="public-about__block" style={{ marginTop: "18px" }}>
          <div className="row align-items-center g-4">
            <div className="col-lg-4">
              <div className="public-about__media public-about__media--compact">
                <img src={`${API}/uploads/${data.affiliation_image}`} alt="Affiliation" className="img-fluid" />
              </div>
            </div>

            <div className="col-lg-8">
              <div className="public-about__copy">
                <p className="public-about__eyebrow">Affiliation & Recognition</p>
                <h2>Nationally Accredited. Globally Recognized.</h2>
                <div dangerouslySetInnerHTML={{ __html: (data.affiliation_text || "").replace(/\n/g, "<br/>") }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
